(() => {
  const initialized = new WeakSet();
  const setup = (root = document) => {
    root.querySelectorAll('.sc-samples').forEach(desk => {
      if (initialized.has(desk)) return;
      initialized.add(desk);
      desk.classList.add("sc-desk-ready");
      const dialog = desk.querySelector('[data-sc-dialog]');
      let opener;
      if (dialog) {
        const close = () => dialog.close();
        dialog.querySelector('[data-sc-dialog-close]').addEventListener('click', close);
        dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
        dialog.addEventListener('close', () => { document.documentElement.classList.remove('sc-preview-open'); opener?.focus(); });
        desk.querySelectorAll('[data-sc-enlarge]').forEach(button => button.addEventListener('click', () => {
          const panel = button.closest('[data-sc-sample-panel]');
          const preview = panel.querySelector('[data-sc-preview]:not([hidden])');
          const image = dialog.querySelector('[data-sc-dialog-image]');
          image.src = preview.currentSrc || preview.src;
          image.alt = preview.alt;
          image.width = preview.width;
          image.height = preview.height;
          dialog.querySelector('[data-sc-dialog-title]').textContent = preview.alt;
          opener = button;
          dialog.showModal();
          dialog.querySelector('.sc-preview-scroll').scrollTop = 0;
          document.documentElement.classList.add('sc-preview-open');
        }));
      }
      const panels = [...desk.querySelectorAll('[data-sc-sample-panel]')];
      panels.forEach(panel => {
        const buttons = [...panel.querySelectorAll('[data-sc-page]')];
        buttons.forEach(button => button.addEventListener('click', () => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panel.querySelectorAll('[data-sc-preview]').forEach(page => page.hidden = page.dataset.scPreview !== button.dataset.scPage);
          panel.querySelector('[data-sc-page-label]').textContent = button.textContent;
        }));
      });
      const tabs = [...desk.querySelectorAll('[data-sc-sample-tab]')];
      const select = tab => {
        tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
        panels.forEach(panel => panel.hidden = panel.dataset.scSamplePanel !== tab.dataset.scSampleTab);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
      if (tabs.length) select(tabs[0]);
    });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sc-nav details[open]').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sc-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
      else if (event.target.closest('a')) details.removeAttribute('open');
    });
  });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const heroes = [...document.querySelectorAll('[data-sc-hero]')];
  let scheduled = false;
  const render = () => {
    scheduled = false;
    heroes.forEach(hero => {
      const box = hero.getBoundingClientRect();
      const depth = (reduced.matches || document.documentElement.dataset.scMotionPaused === 'true') ? 0 : Math.min(38, Math.max(0, -box.top * .09));
      hero.style.setProperty('--sc-depth', `${depth}px`);
    });
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(render); }
  };
  if (heroes.length) {
    addEventListener('scroll', schedule, {passive:true});
    reduced.addEventListener('change', schedule);
    document.addEventListener('sc:motion-change', schedule);
    render();
  }
})();
